import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 6V8L8 8V6L21 6ZM4.4 7L9.4 12L4.4 17L3 15.6L6.6 12L3 8.4L4.4 7ZM21 11V13H11V11H21ZM21 16V18H8V16L21 16Z" }, null, -1)
  ]))]))
}
export default { render: render }